@for (g of controller.ruleReorder.groupsInOrder(); track g.isDefault ? 'default' : g.name) {
  <app-custom-rule-group-panel
    [filter]="filter"
    [group]="g"
    [cosmetic]="cosmetic"
    [showGroupHeader]="controller.enableCustomRuleGroups && !g.isDefault"
    [enableMultipleGroups]="controller.enableCustomRuleGroups"
    [enableRuleLabels]="controller.enableCustomRuleLabels"
    [reorderMode]="controller.ruleReorder.reorder()"
    [draggedRule]="controller.ruleReorder.draggedRule()"
    [draggedGroup]="controller.ruleReorder.draggedGroup()"
    [totalGroupCount]="controller.ruleReorder.groupCount()"
    [dropHighlight]="controller.ruleReorder.dropHighlight()"
    (reorderModeChange)="controller.ruleReorder.setReorder($event)"
    (ruleDragStart)="controller.ruleReorder.onRuleDragStart($event)"
    (ruleDragEnd)="controller.ruleReorder.onRuleDragEnd()"
    (ruleDragEnterTarget)="controller.ruleReorder.onRuleDragEnterTarget($event)"
    (ruleDragOverTarget)="controller.ruleReorder.onRuleDragOverTarget($event)"
    (ruleDragEnterEnd)="controller.ruleReorder.onRuleDragEnterEnd($event)"
    (groupDragStart)="controller.ruleReorder.onGroupDragStart($event)"
    (groupDragEnd)="controller.ruleReorder.onGroupDragEnd()"
    (groupDragEnterHeader)="controller.ruleReorder.onGroupDragEnterHeader($event)"
    (groupDragOverHeader)="controller.ruleReorder.onGroupDragOverHeader($event)"
    (reorderDrop)="controller.ruleReorder.commitDrop()"
    (removeGroup)="controller.removeGroup($event)"
    (afterFilterUpdate)="controller.refreshUiState()"
  >
    @if (g.isDefault && defaultGroupTopSlot) {
      <div class="custom-rule-group-top-slot">
        <ng-container [ngTemplateOutlet]="defaultGroupTopSlot" />
      </div>
    }
  </app-custom-rule-group-panel>

  @if (g.isDefault && g.rules.length > 3 && controller.showEnableCustomRuleGroupsLink) {
    <p class="enable-custom-rule-groups-hint normal-font">
      Need more Custom Rule Groups or Labels? Enable them by clicking <a [href]="null" class="action-link" (click)="controller.enableFromLink($event)">here</a>.
    </p>
  }
}

@if (controller.ruleReorder.dropHighlight(); as h) {
  @if (controller.ruleReorder.reorder() && controller.enableCustomRuleGroups && h.t === 'groupEnd') {
    <div class="reorder-insertion-bar reorder-insertion-bar-groups-end" aria-hidden="true"></div>
  }
}

@if (controller.enableCustomRuleGroups && controller.ruleReorder.reorder() && controller.ruleReorder.groupCount() > 1) {
  <div
    class="custom-rule-groups-end-strip"
    (dragenter)="controller.ruleReorder.onGroupDragEnterEnd($event)"
    (dragover)="controller.ruleReorder.onGroupEndStripDragOver($event)"
    (drop)="controller.ruleReorder.onGroupEndStripDrop($event)"
  ></div>
}

@if (controller.enableCustomRuleGroups) {
  <button
    type="button"
    class="btn clear-btn add-custom-rule-group-btn"
    [class.reorder-passthrough]="controller.ruleReorder.reorder()"
    (click)="controller.addGroup()"
    [disabled]="controller.ruleReorder.reorder()"
  >
    {{ addGroupButtonLabel }}
  </button>
}
